module.exports = __webpack_public_path__ + "img/product-icon-1.0ca6cdfe.png";